// In-memory cache for Discovery responses, kept for the browser session so
// returning to Highlights renders instantly. Entries are keyed by space and
// UTC day, so another space's or another day's data is never served. Bounded
// to the most recently used keys. Pure, no bundler-only imports, so node can
// run the tests.

export const MAX_ENTRIES = 30


export const utcDayKey = (now = new Date()) => {

    return now.toISOString().slice(0, 10)
}


// `kind` separates overview and feed entries that share a params key.
export const sessionCacheKey = ({ kind, spaceId, day, key }) => {

    return [kind, spaceId ?? '', day, key].join('::')
}


export const createSessionCache = (max = MAX_ENTRIES) => {

    const map = new Map()
    return {
        get: (key) => {
            if (!map.has(key)) {
                return null
            }
            // Re-insert so the most recently used key is last.
            const value = map.get(key)
            map.delete(key)
            map.set(key, value)
            return value
        },
        set: (key, value) => {
            map.delete(key)
            map.set(key, value)
            while (map.size > max) {
                map.delete(map.keys().next().value)
            }
        },
        size: () => map.size,
        clear: () => map.clear(),
    }
}


export const discoverySessionCache = createSessionCache()


// Drops everything cached this session (called on logout so the next user on
// the same tab never sees another user's Discovery data).
export const clearDiscoverySessionCache = () => {

    discoverySessionCache.clear()
}
